





































































import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import MIconButton from "@/components/utility/mmmint/MIconButton.vue";
import MNoContent from "@/components/utility/mmmint/MNoContent.vue";
import MSelect from "@/components/utility/mmmint/MSelect.vue";
import MTextField from "@/components/utility/mmmint/MTextField.vue";
import { RepairStatusEnum } from "@/lib/enum/repair.enum";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IRepairDetails, RepairDetails } from "@/models/repair.entity";
import { PartnerModule } from "@/store/modules/partner";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import PartnerReportAppraisalCard from "./repair/PartnerReportAppraisalCard.vue";
import PartnerReportClearancesCard from "./repair/PartnerReportClearancesCard.vue";
import PartnerReportCostEstimateCard from "./repair/PartnerReportCostEstimateCard.vue";
import PartnerReportSelectAppraiserCard from "./repair/PartnerReportSelectAppraiserCard.vue";
import PartnerReportSelectWorkshopCard from "./repair/PartnerReportSelectWorkshopCard.vue";
import RepairDetailForm from "./repair/RepairDetailForm.vue";
import PartnerReportRepairInfo from "./repair/PartnerReportRepairInfo.vue";
import ReportRequestInformationDialog from "../../ReportAttachmentRequestDialog.vue";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";

@Component({
  components: {
    MIconButton,
    MNoContent,
    PartnerReportSelectWorkshopCard,
    PartnerReportSelectAppraiserCard,
    PartnerReportCostEstimateCard,
    PartnerReportAppraisalCard,
    PartnerReportClearancesCard,
    PartnerReportRepairInfo,
    RepairDetailForm,
    ConfirmActionDialog,
    ReportRequestInformationDialog,
    MTextField,
    MSelect
  },
  filters: {}
})
export default class PartnerReportDetailRepair extends mixins(PermissionMixin) {
  isRepairValid = false;
  isRepairDialogOpen = false;
  isRepairLoading = false;
  updateRepair: IRepairDetails | null = null;

  RepairStatusEnum = RepairStatusEnum;
  ReportScreenEnum = ReportScreenEnum;

  get partner() {
    return PartnerModule.partner;
  }

  get report() {
    return PartnerModule.report;
  }

  get reportId() {
    return this.report?.id || "";
  }

  get isMobile(): boolean {
    return this.$vuetify.breakpoint.smAndDown;
  }

  get statusItems() {
    return Object.values(RepairStatusEnum).map(value => ({
      value,
      text: this.$t(`enums.RepairStatusEnum.${value}`)
    }));
  }

  get rentalProvidedItems() {
    return Object.values([true, false]).map(value => ({
      value,
      text: value ? this.$t("yes").toString() : this.$t("no").toString()
    }));
  }

  get workshopSharedContent() {
    return this.report.workShopCompany?.sharedContent?.[0];
  }

  startAddRepairDetails() {
    this.isRepairDialogOpen = true;
    this.updateRepair = new RepairDetails(this.report.repair);
  }

  async updateRepairDetails() {
    if (!this.updateRepair) {
      return;
    }

    try {
      this.isRepairLoading = true;
      await this.report.updatePartial({ repair: this.updateRepair });
      this.isRepairDialogOpen = false;
    } catch (error) {
      handleError(error);
    } finally {
      this.isRepairLoading = false;
    }
  }

  async mounted() {
    await this.report.workShopCompany?.fetchSharedContent(this.report.id);
  }
}
